import { render, staticRenderFns } from "./DeceasedMother.vue?vue&type=template&id=1f4e287f&scoped=true&lang=pug&"
import script from "./DeceasedMother.vue?vue&type=script&lang=js&"
export * from "./DeceasedMother.vue?vue&type=script&lang=js&"
import style0 from "./DeceasedMother.vue?vue&type=style&index=0&id=1f4e287f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e287f",
  null
  
)

export default component.exports